/* eslint-disable react-hooks/exhaustive-deps */
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import "../css/Topbar.css";
import { requestWithHeaders } from "../api/requestMethods";

export default function Topbar() {
  const [profile, setProfile] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("token") === "") {
      navigate("/login");
    }

    const fetchData = async () => {
      try {
        const res = await requestWithHeaders.get("/api/user/profile");
        setProfile(res?.data?.data);
      } catch (error) {
        console.log(error);
        if (
          error.response?.data?.message === "Token Expired!" ||
          error.response?.data?.message === "Authentication Failed!"
        ) {
          navigate("/login");
          return;
        }
      }
    };
    fetchData();
  }, []);

  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = (e) => {
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  function handleLogout() {
    localStorage.removeItem("token");
    navigate("/login");
  }

  return (
    <>
      <nav className="navbar topbar-css navbar-expand topbar static-top shadow">
        <img src="images/ult-upnvj-1.png" alt="vector" />
        <div className="ml-1">
          <div style={{ color: "white", fontSize: 12, fontWeight: 800 }}>
            Unit Layanan Terpadu
          </div>
          <div style={{ color: "white", fontSize: 12, fontWeight: 800 }}>
            UPN Veteran Jakarta
          </div>
        </div>

        <ul className="navbar-nav ml-auto">
          <li className="nav-item dropdown no-arrow">
            <a
              className="nav-link dropdown-toggle-custom"
              href="/#"
              id="userDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded={isOpen}
              style={{ display: "flex", alignItems: "center" }}
              onClick={(e) => toggleDropdown(e)}
            >
              <span
                className="mr-2 d-none d-lg-inline small"
                style={{ fontWeight: 700, fontSize: 16, color: "white" }}
              >
                {profile?.fullname}
              </span>
              <img
                className="img-profile rounded-circle"
                src="images/vector-4.png"
                alt="profile"
                style={{ width: "25px", height: "25px" }}
              />
            </a>

            {isOpen && (
              <div className="d-flex justify-content-end">
                <div
                  className="custom-dropdown-menu"
                  style={{
                    position: "absolute",
                    backgroundColor: "#fff",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                    borderRadius: "5px",
                    minWidth: "150px",
                  }}
                >
                  <button
                    className="dropdown-item"
                    style={{
                      padding: "10px 15px",
                      display: "block",
                      color: "#333",
                      textDecoration: "none",
                      backgroundColor: "transparent",
                      border: "none",
                      cursor: "pointer",
                    }}
                    onClick={handleLogout}
                  >
                    Logout
                  </button>
                </div>
              </div>
            )}
          </li>
        </ul>
      </nav>

      <a className="scroll-to-top rounded" href="#page-top">
        <i className="fas fa-angle-up"></i>
      </a>
      <div
        className="modal fade"
        id="logoutModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Ready to Leave?
              </h5>
              <button
                className="close"
                type="button"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              Select "Logout" below if you are ready to end your current
              session.
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-secondary"
                type="button"
                data-dismiss="modal"
                id="cancelBtn"
              >
                Cancel
              </button>
              <button className="btn btn-primary">Logout</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
